import { ActionTree } from "vuex";
import { AuthenticationState } from "./types";
import { RootState } from "@/store/types";
import { azureLogin, azureLogout, configAutoLogout } from "@/services/security/authService";

export const actions: ActionTree<AuthenticationState, RootState> = {
    azureLoginAction({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            azureLogin()
                .then((response: any) => {
                    commit("authSuccess", response.data);
                    configAutoLogout();
                    resolve(response);
                })
                .catch((reason: any) => {
                    reject(reason);
                });
        });
    },
    logoutAction({ commit, state }) {
        if (state.currentUser.isRegularUser) {
            commit("authClear");
        } else {
            azureLogout().then(() => {
                commit("authClear");
            });
        }
    },
    validateToken({ commit, state }) {
        if (state.tokenValidTo != null) {
            const tokenValidTo: Date = new Date(state.tokenValidTo);
            if (tokenValidTo < new Date()) {
                commit("authClear");
            }
        }
    }
};
